import { render, staticRenderFns } from "./dataBarangKeluar.vue?vue&type=template&id=0ca24e45&scoped=true&"
import script from "./dataBarangKeluar.vue?vue&type=script&lang=js&"
export * from "./dataBarangKeluar.vue?vue&type=script&lang=js&"
import style0 from "./dataBarangKeluar.vue?vue&type=style&index=0&id=0ca24e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca24e45",
  null
  
)

export default component.exports